export default __webpack_public_path__ + "static/media/website-banner-fertility-mb.cfc61a7c.jpg";